import axios from 'axios';
import Vue from 'vue';
import zenscroll from 'zenscroll';
import Errors from '../classes/errors';
import {
    handleCloseDropdownOnBlur,
    handleLoadSharpsringScriptUrl,
    handleSetSharpspringScript,
    handleSharpspringSubmit,
    setCaptchaEuScript,
} from '../utils';

Vue.component('configurator-new-form-component', {
    props: {
        siteHandle: {
            value: String,
        },
        stores: {
            value: Array,
        },
        captchaEuPublicKey: {
            value: String,
        },
        isCaptchaEuEnabled: {
            value: Boolean,
        },
        sharpspringBaseUrl: {
            value: String,
        },
        sharpspringEndpointId: {
            value: String,
        },
        sharpspringScriptUrl: {
            value: String,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            modelName: '',
            offerTranslations: null,
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            countryHandle: '',

            dropdownHeardFrom: null,
            heardFrom: null,

            internalCountryHandle: '',
            dropdownCountry: null,
            frBrandStores: {
                martinique: 'MG Martinique (97232 Le Lamentin)',
                guadeloupe: 'MG Guadeloupe (97122 Baie-Mahault)',
                guyane: 'MG Guyane (97324 Cayenne Cedex)',
                mayotte: 'MG Mayotte (97 600 Mamoudzou)',
            },

            guyane: 'GF',
            martinique: 'GF',
            mayotte: 'YT',
            reunion: 'RE',
            guadeloupe: 'GP',

            selectedBrandStore: null,

            salesforceInterestEdition: '',
            salesforceInterestVersion: '',

            isSwitchButtonVisible: true, // used only for germany configurator (corporate switch)
            requestIndex: 0, // used only for germany configurator (corporate switch)
            requestType: 'private', // used only for germany configurator (corporate switch)
        };
    },

    computed: {
        orderedStores: function () {
            return _orderBy(this.stores, 'title');
        },

        isSubmitLoading() {
            return this.submitting ? 'button--loading' : '';
        },

        configurationJson() {
            const configuration = this.getConfigurationJson();

            this.modelName = this.$parent.data.generalTranslations.modelName;
            this.salesforceInterestEdition =
                this.$parent.data.edition.salesforceInterestEdition;
            this.salesforceInterestVersion =
                this.$parent.data.edition.salesforceInterestVersion;
            this.offerTranslations = this.$parent.data.offerTranslations;

            return JSON.stringify(configuration);
        },

        isCompanyInputVisible() {
            return (
                this.requestType === 'business' &&
                ['mgMotorsGermany', 'mgMotorsFrance', 'mgMotorsSpain'].includes(
                    this.siteHandle,
                )
            );
        },
    },

    watch: {},

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        if (this.siteHandle !== 'default') {
            this.countryHandle = this.siteHandle;
        }

        handleSetSharpspringScript(
            this.siteHandle,
            this.sharpspringBaseUrl,
            this.sharpspringEndpointId,
            'configuratorForm',
        );
        handleLoadSharpsringScriptUrl(
            this.siteHandle,
            this.sharpspringScriptUrl,
        );

        setCaptchaEuScript();

        handleCloseDropdownOnBlur('#heard-from-dropdown');
        handleCloseDropdownOnBlur('#brandstore-dropdown');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        handleToggleButtonActiveClass(index) {
            return this.requestIndex === index ? 'checked' : '';
        },

        scrollToFirstError() {
            Vue.nextTick(() => {
                let firstError = document.querySelector(
                    '.new-input__container--error',
                );
                zenscroll.center(firstError);
            });
        },

        scrollToTop() {
            Vue.nextTick(() => {
                zenscroll.toY(0);
            });
        },

        setDropdownCountry(event) {
            this.toggleDropdown(event);

            this.dropdownCountry = event.currentTarget.dataset.text;
            this.countryHandle = event.currentTarget.dataset.value;
            this.internalCountryHandle = event.currentTarget.dataset.dorm;

            const territory = event.currentTarget.dataset.dorm;
            if (
                ['guyane', 'guadeloupe', 'martinique', 'mayotte'].includes(
                    territory,
                )
            ) {
                this.internalCountryHandle = territory;
                this.frBrandStoreHandle = territory;
                this.dropdownFrStore = this.frBrandStores[territory];

                this.dropdownFrStoreValue = this.frBrandStores[territory];

                return;
            }

            if (territory === 'reunion') {
                this.internalCountryHandle = territory;
                this.frBrandStoreHandle = 'MG Saint-Pierre (97 410)';
                this.dropdownFrStore = 'MG Saint-Pierre (97 410)';
                this.dropdownFrStoreValue = 'MG Saint-Pierre (97 410)';
            }
        },

        setDropdownFrBrandStore(event) {
            const text = event.currentTarget.dataset.text;
            this.dropdownFrStore = text;
            this.dropdownFrStoreValue = text;

            this.frBrandStoreHandle = event.currentTarget.dataset.value;

            this.toggleDropdown(event);
        },

        toggleDropdown(event) {
            event.preventDefault();
            let element = event.currentTarget;
            while ((element = element.parentElement)) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');
                }
            }
        },

        setDropdownHeardFrom(event) {
            this.dropdownHeardFrom = event.currentTarget.dataset.text;
            this.heardFrom = event.currentTarget.dataset.value;

            this.toggleDropdown(event);
        },

        brandStoreSelected(store) {
            this.selectedBrandStore = store;
        },

        async onSubmit(event) {
            event.preventDefault();
            const form = event.currentTarget;
            let dataFromForm = new FormData(form);
            let data = {};

            for (let [key, val] of dataFromForm.entries()) {
                Object.assign(data, { [key]: val });
            }

            if (
                this.siteHandle === 'mgMotorsFrance' &&
                this.agricoleDodDescription
            ) {
                data = {
                    ...data,
                    message: this.agricoleDodDescription,
                };
            }

            // Don't submit twice.
            if (this.submitting) {
                return;
            }

            this.submitting = true;

            try {
                if (!this.isCaptchaEuEnabled) {
                    await this.handleDataSubmit();
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(captchaSolution);
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        getConfigurationJson() {
            const priceIndication = this.$parent.data.finance.priceText.replace(
                '{price}',
                this.$parent.data.totalPrice,
            );

            return {
                color: {
                    key: this.$parent.data.exterior.uniqueKey,
                    name: this.$parent.data.exterior.selectionTitle,
                    metallic: this.$parent.data.exterior.isMetallicColor
                        ? 1
                        : 0,
                    productCode: this.$parent.data.exterior.productCode,
                },
                type: {
                    id: this.$parent.data.entryId,
                    key: this.$parent.data.edition.uniqueKey,
                    name: this.$parent.data.edition.editionTitle,
                    productCode: this.$parent.data.edition.productCode,
                },
                options: {
                    hood: {
                        key: this.$parent.data.hood.uniqueKey,
                        name: this.$parent.data.hood.selectionTitle,
                        productCode: this.$parent.data.hood.productCode,
                    },
                    interior: {
                        key: this.$parent.data.interior.uniqueKey,
                        name: this.$parent.data.interior.selectionTitle,
                        productCode: this.$parent.data.interior.productCode,
                    },
                    interiorMaterial: {
                        key: this.$parent.data.interiorMaterial.uniqueKey,
                        name: this.$parent.data.interiorMaterial.selectionTitle,
                        productCode:
                            this.$parent.data.interiorMaterial.productCode,
                    },
                },
                //add promotions later
                promotions: {},
                version: {},
                price: {
                    key: this.$parent.data.finance.financingHandle,
                    name: this.$parent.data.finance.financingTitle,
                    shopPrice: null,
                    shopPriceAdditionMetallic: null,
                    shopPriceAdditionSpecificColor: null,
                },
                totalPriceIndication: priceIndication,
                priceIndication: priceIndication,
                disclaimer: '',
            };
        },

        async handleDataSubmit(captchaSolution) {
            try {
                const formData = new FormData(this.$refs.form);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }

                const response = await axios.post('/', formData);
                const result = response.data;

                // Handle form errors.
                if (result.data.errors) {
                    this.errors.clear();
                    this.errors.record(result.data.errors);
                    this.submitting = false;
                    this.scrollToFirstError();
                    return;
                }

                handleSharpspringSubmit(
                    this.siteHandle,
                    this.sharpspringEndpointId,
                );

                window.location = result.data.redirectUrl;
            } catch (e) {
                throw new Error(e);
            }
        },
    },
});
